// src/constants/deliveryConstants.js

export const DELIVERY_STATUS = {
  PROCESSING: 'PROCESSING',
  SHIPPED: 'SHIPPED',
  ON_THE_WAY: 'ON_THE_WAY',
  BOOK_WITH_ME: 'BOOK_WITH_ME',
  RETURN_REQUESTED: 'RETURN_REQUESTED',
  PICKUP_SCHEDULED: 'PICKUP_SCHEDULED',
  RETURN_IN_TRANSIT: 'RETURN_IN_TRANSIT',
  RETURNED: 'RETURNED',
  CANCELLED: 'CANCELLED'
};

export const STATUS_FILTER_OPTIONS = [
  { value: 'ALL', label: 'All Forward Orders' },
  { value: 'PROCESSING', label: 'Processing' },
  { value: 'SHIPPED', label: 'Shipped' },
  { value: 'ON_THE_WAY', label: 'On the Way' },
  { value: 'BOOK_WITH_ME', label: 'Delivered' }
];

export const RETURN_STATUS_OPTIONS = [
  { value: 'ALL_RETURNS', label: 'All Returns' },
  { value: 'RETURN_REQUESTED', label: 'Return Requested' },
  { value: 'PICKUP_SCHEDULED', label: 'Pickup Scheduled' },
  { value: 'RETURN_IN_TRANSIT', label: 'In Transit' },
  { value: 'RETURNED', label: 'Returned' }
];

export const ORDERS_PER_PAGE = 20;

export const API_ENDPOINTS = {
  LOGIN: '/login',
  PROFILE: '/profile',
  ORDERS: '/orders',
  UPDATE_STATUS: '/orders/:orderId/status',
  STATS: '/stats'
};
